import { Grid } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { ProductList } from "./product";
import { AddEditProduct } from "./addEditProduct";
import { Inventory } from "./inventory";
import { RestockProduct } from "./restock";
import { Reviews } from "./reviews";
import { Package } from "./packages";
import { AddEditPackage } from "./addEditPackage";

const tabs = [
  { label: "productList", value: "productList" },
  { label: "basePackages", value: "base_packages_list" },
  { label: "allReviews", value: "all_reviews" },
  { label: "restockProduct", value: "restock_product" },
  { label: "inventoryMovements", value: "inventory_movements" },

  // { label: "addNewProduct", value: "addNewProduct" },
  // { label: "packageList", value: "package_list" },
  // { label: "reviews", value: "reviews" },
];

function SupplierAddEditProducts() {
  const dispatch = useDispatch();
  const [productsCount, setProductCounts] = useState({
    uploadedProductsCount: 0,
    activeProductsCount: 0,
    uploadedPackageCount: 0,
    activePackageCount: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const userData = useSelector((state) => state.userData.user);
  const canUpload = userData?.canUpload <= productsCount.uploadedProductsCount;

  // useEffect(() => {
  //   if (userData) {
  //     fetchchedUploadedProducts();
  //   }
  // }, [userData]);

  // const fetchchedUploadedProducts = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await supplierUploadedProducts(userData?._id);
  //     if (response?.data?.status === "success") {
  //       const data = response?.data?.data;
  //       setProductCounts({
  //         uploadedProductsCount: data?.uploadedProductsCount,
  //         activeProductsCount: data?.activeProductsCount,
  //         uploadedPackageCount: data?.uploadedPackageCount,
  //         activePackageCount: data?.activePackageCount,
  //       });
  //     } else {
  //       handleOpenSnackBar("error", response?.data?.message);
  //     }
  //   } catch (error) {
  //     handleOpenSnackBar("error", error?.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, catalogue: tab }));
  };

  const renderTabs = (activeTab) => {
    switch (activeTab) {
      case "productList":
        return <ProductList handleChangeTab={handleChangeTab} />;
      case "add_edit_product":
        return <AddEditProduct handleChangeTab={handleChangeTab} />;
      case "base_packages_list":
        return <Package handleChangeTab={handleChangeTab} />;
      case "add_edit_package":
        return <AddEditPackage handleChangeTab={handleChangeTab} />;
      case "all_reviews":
        return <Reviews handleChangeTab={handleChangeTab} />;
      case "restock_product":
        return <RestockProduct handleChangeTab={handleChangeTab} />;
      case "inventory_movements":
        return <Inventory handleChangeTab={handleChangeTab} />;
      default:
        return null;
    }
  }

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={t("catalog")}
            tabs={tabs}
            activeTab={activeTab.catalogue}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {renderTabs(activeTab.catalogue)}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default SupplierAddEditProducts;
